module.exports = __webpack_public_path__ + "img/ylomi_logo.fe276f11.jpg";